import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Formik, Form } from 'formik';

import Options from '../shared/Options';
// import DebugData from '../shared/DebugData';
import OptionWithIcon from './OptionIcon';
import {
  goalDueDate,
  carGoalMoneyRequired,
  propertyGoalMoneyRequired,
  emergencyFundGoalMoneyRequired,
  educationGoalMoneyRequired,
  retirementGoalMoneyRequired,
  weddingGoalMoneyRequired,
  customGoalMoneyRequired,
  retirementGoalDueDate,
  weddingGoalDueDate,
} from '../../constants/questionnaires';
import GoalModal from './GoalModal';
import Button from '../shared/Button';
import { ThemeShape, Default } from '../theme/Options';
import Title from '../shared/Title';
import Text from '../shared/Text';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';

import { HEADER_HEIGHT, FlowHeader } from './styles';
import { breakpoints } from '../../constants/styles';

const StyledGoalsPicker = styled.div`
  padding: 0 20px;
  margin-top: ${HEADER_HEIGHT}px;
  width: 100%;
  background-color: white;

  ${breakpoints.tablet} {
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
  }
`;

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

const SubmitButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledGoalsPickerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledButton = css`
  cursor: pointer;
  box-shadow: 2px 2px 15px -3px rgba(0, 0, 0, 0.25);
  margin-bottom: 40px;
  margin-top: 0.3rem;
`;

const StyledPickerTitle = css`
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: -10px;
`;

const Goals = [
  {
    label: 'Auto',
    value: 'Auto',
    icon: 'goalCar',
    questions: [...goalDueDate, carGoalMoneyRequired],
    dimensions: 40,
  },
  {
    label: 'Propiedad',
    value: 'Propiedad',
    icon: 'goalHouse',
    questions: [...goalDueDate, propertyGoalMoneyRequired],
    dimensions: 40,
  },
  {
    label: 'Boda',
    value: 'Boda',
    icon: 'boda',
    questions: [...weddingGoalDueDate, weddingGoalMoneyRequired],
    dimensions: 40,
  },
  {
    label: 'Posgrado',
    value: 'Posgrado',
    icon: 'goalEducation',
    questions: [...goalDueDate, educationGoalMoneyRequired],
    dimensions: 35,
  },
  {
    label: 'Retiro',
    value: 'Retiro',
    icon: 'goalRetirement',
    questions: [...retirementGoalDueDate, retirementGoalMoneyRequired],
    dimensions: 40,
  },
  {
    label: 'Fondo de emergencia',
    value: 'Fondo_de_emergencia',
    icon: 'lifebuoyNoGradient',
    questions: [...goalDueDate, emergencyFundGoalMoneyRequired],
    dimensions: 35,
  },
  {
    label: 'Otra meta',
    value: '',
    icon: 'add',
    questions: [],
    dimensions: 35,
    runCallback: true,
  },
];

class GoalsPicker extends Component {
  state = {
    isModalOpened: false,
    goals: [...Goals],
    defaultValues: { goals: [] },
    importantKeyIsDown: false,
  };

  openModal = () => this.setState({ isModalOpened: true });

  closeModal = () => this.setState({ isModalOpened: false });

  handleCreateGoal = (values) => {
    const newValue = {
      label: values.customGoal,
      value: values.customGoal.replace(/ /g, '_'),
      questions: [...goalDueDate, customGoalMoneyRequired],
      icon: 'goalNoGradient',
      dimensions: 35,
    };

    // TODO: Encontrar manera de que meta que agreguemos
    // Aparezca en la posición n - 1

    this.setState({
      goals: [...this.state.goals, newValue],
    });

    values.customGoal = '';
  };

  isGoalListEmpty = (props) => {
    const goals = props.values.goals || [];
    return goals.length === 0;
  };

  componentDidMount = () => {
    document.addEventListener('keyup', this.keyUp, false);
    document.addEventListener('keydown', this.keyDown, false);
  };

  componentWillUnmount() {
    document.removeEventListener('keyup', this.keyUp, false);
    document.removeEventListener('keydown', this.keyDown, false);
  }

  keyDown = (ev) => {
    console.log('keyDownQuestionBlock');
    switch (ev.keyCode) {
      case 65:
      case 97:
      case 66:
      case 98:
      case 67:
      case 99:
      case 68:
      case 100:
      case 69:
      case 101:
      case 70:
      case 102:
      case 71:
      case 103:
      case 72:
      case 104:
      case 73:
      case 105:
      case 74:
      case 106:
        if (!this.state.importantKeyIsDown) {
          console.log('aaa');
          this.setState({ importantKeyIsDown: true });
        }
        break;
      default:
        break;
    }
  };

  callback = () => {
    console.log('callbackQuestionBlock');
    this.setState({ importantKeyIsDown: false });
  };

  render() {
    const { importantKeyIsDown } = this.state;
    return (
      <StyledGoalsPickerContainer>
        <ScrollToTopOnMount />
        <FlowHeader>
          {/* TODO: Make this title a prop and pass it all the way from the container */}
          <Title
            level={5}
            color="white"
            styles={css`
              margin-bottom: 0px;
            `}
            medium
          >
            Creando tu mapa financiero
          </Title>
        </FlowHeader>
        <StyledGoalsPicker>
          <Title level={3} styles={StyledPickerTitle}>
            Selecciona todas tus metas
          </Title>
          <Formik
            onSubmit={(values, { setSubmitting }) => {
              if (!values.goals) {
                this.props.onStepSubmit(this.state.defaultValues);
              } else {
                this.props.onStepSubmit(values);
              }
              setSubmitting(false);
            }}
          >
            {(props) => (
              <StyledForm>
                <Options
                  importantKeyIsDown={importantKeyIsDown}
                  name="goals"
                  values={this.state.goals}
                  renderItem={(
                    { icon, label, dimensions }, // Chulada! 👌
                  ) => (
                    <OptionWithIcon icon={icon} dimensions={dimensions}>
                      {label}
                    </OptionWithIcon>
                  )}
                  callback={this.openModal}
                  multiple
                />
                <SubmitButtonContainer>
                  <Button
                    type="submit"
                    disabled={this.isGoalListEmpty(props)}
                    color={!this.isGoalListEmpty(props) ? 'default' : 'disabled'}
                    styles={StyledButton}
                  >
                    <Text type="buttonText" color="white" medium>
                      → Listo
                    </Text>
                  </Button>
                </SubmitButtonContainer>
                {/* <DebugData data={props} /> */}
              </StyledForm>
            )}
          </Formik>
          <GoalModal
            show={this.state.isModalOpened}
            onCreateGoal={this.handleCreateGoal}
            onCloseModal={this.closeModal}
          />
        </StyledGoalsPicker>
      </StyledGoalsPickerContainer>
    );
  }
}

GoalsPicker.propTypes = {
  onStepSubmit: PropTypes.func,
  theme: ThemeShape,
};

GoalsPicker.defaultProps = {
  onStepSubmit: () => {},
  theme: Default,
};

export default GoalsPicker;
